import BaseScene from './BaseScene'
import { ScorerSpeed, WalkSpeed, BrownianSpeed } from './Constants'

export default class Substitution extends BaseScene {
    constructor(event, pitch) {
        super(pitch);

        this.Team = event.team;
        this.In = event.in;
        this.Out = event.out;

        let keyPoints = pitch.getKeyPoints(this.Team == 1);
        this.SubstitutionPoint = keyPoints.substitutionPoint;
        this.BenchSlotPoint = keyPoints.benchSlots[this.In - 11];
        this.CenterPoint = keyPoints.center;
    }

    Play(gameSpeed) {
        return new Promise(function(resolve, reject) {
            let outPlayer = this.GetPlayer(this.Team, this.Out);
            let inPlayer = this.GetPlayer(this.Team, this.In);

            this.HighLightPlayers([inPlayer, outPlayer]);

            this.getPlayers((player) => player.props.index < 11 && !this.PlayerIn(player, [outPlayer, inPlayer]))
                .forEach((player) => player.WalkToNextPosition(gameSpeed, WalkSpeed).then(() => player.BrownianMovement(gameSpeed)));

            let outPlayerPosition = outPlayer.getNextPosition();

            //выходящий подходит к месту замены
            var inPlayerMove = inPlayer.MoveToWithSpeed(gameSpeed, WalkSpeed, this.SubstitutionPoint, {useBrownian: true});

            //уходящий подходит к месту замены
            var outPlayerMove = outPlayer.MoveToWithSpeed(gameSpeed, WalkSpeed*2, this.SubstitutionPoint, {useBrownian: false});

            Promise.all([inPlayerMove, outPlayerMove]).then(() => {
                this.HighLightPlayers([inPlayer]);//снимаем подцветку с заменяемого
                
                outPlayer.wasSubOut = true;
                outPlayer.MoveToWithSpeed(gameSpeed, WalkSpeed, this.BenchSlotPoint); //занимает место на скамейке
                inPlayer.MoveToWithSpeed(gameSpeed, WalkSpeed*2, outPlayerPosition).then(resolve); // выбигает на место ушедшего
            })
            
        }.bind(this));
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Animations/Scenes/Substitution.js
 **/